import { h, Component } from 'preact'
import { connectWithTranslations } from '../../common/helpers/translationsHelpers'

class EventListHeaderMobile extends Component {
    render({ translate }) {
        return (
            <thead class="fxs_c_header">
                <tr>
                    <th class="fxs_c_item ">{translate('HeaderTime')}</th>
                    <th class="fxs_c_item  fxs_c_item_event_name">{translate('HeaderEvent')}</th>
                    <th class="fxs_c_item "></th>
                    <th class="fxs_c_item fxs_c_actual">{translate('HeaderActual')}</th>
                    <th class="fxs_c_item "></th>
                </tr>
            </thead>
        )
    }
}

export default connectWithTranslations()(EventListHeaderMobile)
